import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useRef, useEffect } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-thread.module.scss.js';

const PageThread = () => {
  const ref = useRef(null);
  const label = useLabel();
  const {
    ChunkWrapper,
    Feedback,
    PageLoading,
    Stream
  } = useLlm(state => state.components);
  const enableFeedback = useLlm(state => {
    var _a;
    return (_a = state.app) === null || _a === void 0 ? void 0 : _a.contents.enableFeedback;
  });
  const messages = useLlm(state => state.messages);
  const message = useLlm(state => state.message);
  const streaming = useLlm(state => state.streaming);
  const hasValidChunks = useLlm(state => (state.chunks || []).reduce((p, c) => {
    return p || !['header', 'log', 'info', 'end'].includes(c.type);
  }, false));
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
    /*
    if (ref.current) {
      ref.current.scrollIntoView();
    }
    */
  }, [message, hasValidChunks]);
  const classNames = getClassNames(style.thread);
  // console.log('message', message);
  return jsx("section", {
    ref: ref,
    className: classNames,
    children: hasValidChunks ? jsx(Stream, {
      className: getClassNames(style.message, '-assistant'),
      index: messages.length
    }) : streaming ? jsx(PageLoading, {}) : jsx(Fragment, {
      children: message && jsxs("div", {
        className: getClassNames(style.message, `-${message.role}`),
        role: "region",
        "aria-label": message.role === 'user' ? label('llm.question') : label('llm.answer'),
        children: [message.chunks.map((chunk, c) => jsx(ChunkWrapper, {
          className: getClassNames(style.messageInner, `-${chunk.type}`),
          item: chunk,
          chunkIndex: c,
          index: 0,
          total: messages.length,
          role: message.role
        }, `llm-message-${message.messageId}-chunk-${c}`)), enableFeedback && jsx(Feedback, {
          message: message
        })]
      }, `llm-message-${message.messageId}-0`)
    })
  });
};

export { PageThread };
//# sourceMappingURL=page-thread.js.map
